var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { muiBankFill } from '@ally/metronome-icons';
import { Icon } from '../../Icon';
import { Space } from '../../Space';
import { TextBodyDEPRECATED } from '../../TypographyDEPRECATED';
var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  transition: height 0.35s;\n  height: ", ";\n  box-sizing: border-box;\n"], ["\n  overflow: hidden;\n  transition: height 0.35s;\n  height: ", ";\n  box-sizing: border-box;\n"])), function (_a) {
    var show = _a.show;
    return (show ? '40px' : '1px');
});
var StyledHolidayLegendWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  padding: 0 0 15px 25px;\n  align-items: center;\n"], ["\n  display: flex;\n  padding: 0 0 15px 25px;\n  align-items: center;\n"])));
var HolidayLegend = function (_a) {
    var holidays = _a.holidays;
    var _b = __read(useState(''), 2), displayedHolidays = _b[0], setDisplayedHolidays = _b[1];
    useEffect(function () {
        setDisplayedHolidays(holidays.join(', '));
    }, [holidays, setDisplayedHolidays]);
    return (React.createElement(StyledContainer, { show: !!holidays.length },
        React.createElement(StyledHolidayLegendWrapper, null,
            React.createElement(Icon, { icon: muiBankFill, size: "md", fill: "slate-4", mr: "xs" }),
            React.createElement(Space, { mr: "xxs" },
                React.createElement(TextBodyDEPRECATED, { tag: "span", size: "sm", weight: "bold", color: "slate-4" }, "Federal Holidays:")),
            React.createElement(TextBodyDEPRECATED, { tag: "span", size: "sm", color: "slate-4" }, displayedHolidays))));
};
export { HolidayLegend };
var templateObject_1, templateObject_2;
//# sourceMappingURL=HolidayLegend.js.map